import { Controller, useFormContext } from "react-hook-form";
import { MemoPicker } from "./MemoPicker";

interface LocationPickerProps {
  [key: string]: any;
  name: string;
  rules?: any;
}

interface MemoPickerProps {
  [key: string]: any;
  autoFocus: boolean;
  placeholder: string;
}

export const LocationPicker = ({
  name,
  rules,
  ...passThroughProps
}: LocationPickerProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value, name } }) => (
        <MemoPicker
          {...(passThroughProps as MemoPickerProps)}
          name={name}
          onChange={onChange}
          value={value}
        />
      )}
    />
  );
};

LocationPicker.displayName = "Form.LocationPicker";
